import { tateConfig, yokoConfig } from './sheet.config'

export const S1_CW2503_TestA_211115 = {
  FRONT: {
    EXAM_GROUP_KEY: '02124003111',
    QR_INFO: {
      checkDigit: 1319,
      correctSize: tateConfig.correctedSize,
      correctMarkers: tateConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: tateConfig.correctedRotateQrPos,
      numCheckPosition: tateConfig.correctedNumCheckArea,
      clipScale: 0.8,
      isHorizontal: false
    }
  },
  REVERSE: {
    EXAM_GROUP_KEY: '02124003122',
    QR_INFO: {
      checkDigit: 1320,
      correctSize: yokoConfig.correctedSize,
      correctMarkers: yokoConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: yokoConfig.correctedRotateQrPos,
      numCheckPosition: yokoConfig.correctedNumCheckArea,
      clipScale: 1.0,
      isHorizontal: true
    }
  }
} as const
